/**
 * Bridges Pebble theme cart/product events to TikTok server events helpers.
 * Depends on: window.TikTokConfig, window.tiktokServerEvents (from tiktok-server-events.js)
 */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function getTikTok() {
    return window.tiktokServerEvents || null;
  }

  function trackViewContentFromConfig() {
    var tt = getTikTok();
    var config = window.TikTokConfig;
    if (!tt || !config || config.pageType !== 'product' || !config.productId) return;

    if (typeof tt.trackViewContent === 'function') {
      // Prefer config data; trackViewContent also reads DOM [data-product-id]
      tt.trackViewContent();
    }
  }

  function normalizeAddToCartDetail(detail) {
    var config = window.TikTokConfig || {};
    var product = detail && (detail.product || detail);
    var item = product && product.items && product.items[0];

    if (item) {
      return {
        id: String(item.product_id || item.id || config.productId || ''),
        title: item.product_title || item.title || config.productTitle || 'Product',
        price: (item.final_price != null ? item.final_price : item.price != null ? item.price : 0) / 100,
      };
    }

    if (config.productId) {
      return {
        id: String(config.productId),
        title: config.productTitle || 'Product',
        price: Number(config.productPrice) || 0,
      };
    }

    return null;
  }

  function onProductAjaxAdded(event) {
    var tt = getTikTok();
    if (!tt || typeof tt.trackAddToCart !== 'function') return;
    var data = normalizeAddToCartDetail(event.detail);
    if (data && data.id) tt.trackAddToCart(data);
  }

  function onCartUpdated(event) {
    var tt = getTikTok();
    var cart = event.detail && event.detail.cart;
    if (!tt || !cart) return;

    if (typeof tt.updateCartInfo === 'function') {
      tt.updateCartInfo();
    }

    // Refresh config cart totals when available
    if (window.TikTokConfig) {
      window.TikTokConfig.cartTotal = (cart.total_price || 0) / 100;
    }
  }

  function onCheckoutClick(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var link = target.closest('a[href*="/checkout"], button[name="checkout"], [href="/checkout"]');
    if (!link) return;
    var tt = getTikTok();
    if (tt && typeof tt.trackInitiateCheckout === 'function') {
      tt.trackInitiateCheckout();
    }
  }

  ready(function () {
    // Wait a tick so deferred tiktok-server-events can init
    setTimeout(function () {
      trackViewContentFromConfig();
    }, 0);

    document.addEventListener('product-ajax:added', onProductAjaxAdded);
    document.addEventListener('cart:updated', onCartUpdated);
    document.addEventListener('click', onCheckoutClick, true);

    if (window.location.pathname.indexOf('/cart') !== -1) {
      var tt = getTikTok();
      var config = window.TikTokConfig;
      if (tt && config && typeof config.trackEvent === 'function') {
        config.trackEvent('ViewCart', config.getCartData());
      }
    }
  });
})();
